module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-card-action-buttons"
  }, [(_vm.actions.length) ? _c('div', {
    staticClass: "dropdown-buttons"
  }, _vm._l((_vm.actions), function(action) {
    return _c('button', {
      key: action.name,
      staticClass: "button",
      class: action.severity,
      attrs: {
        "type": "button"
      },
      on: {
        "click": action.callback
      }
    }, [_vm._v(_vm._s(action.name))])
  }), 0) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('span', [_vm._v("No actions available")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30ab24e2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CardActionButtons.vue
// module id = 2388
// module chunks = 1